import React from 'react';
import { ArrowRightIcon, CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses } from '../../data/bonuses';
import { CTAButton } from '../CTAButton';
export function Bonuses() {
  return <section className="w-full bg-navy-950 py-14 text-white md:py-20" aria-labelledby="bonuses-title" data-id="element-89" data-mp="1cko88ijx3gbs">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-90" data-mp="18k49xbnly6o2">
        <div className="text-center" data-id="element-91" data-mp="18hhvqt67oswv">
          <span className="inline-flex items-center gap-2 rounded-full bg-gold-500 px-4 py-1.5 font-display text-[11px] font-black uppercase tracking-[0.2em] text-navy-950" data-id="element-92" data-mp="25ada0y4gbkeg">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-93" data-mp="1w95dollhwtn0" />
            Exclusive bonuses
          </span>
          <h2 id="bonuses-title" className="mt-4 font-display text-[26px] font-black uppercase leading-tight tracking-tight sm:text-4xl" data-id="element-94" data-mp="1racb3o7qyn1m">
            Included Free Today
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-[14px] leading-relaxed text-brand-100/80 sm:text-base" data-id="element-95" data-mp="funncumo5jzr">
            Designed to make your Case Commander faster, easier, and more practical to use.
          </p>
        </div>

        <div className="mt-8 space-y-6 md:mt-12 md:space-y-8" data-id="element-96" data-mp="1js80xdnhgcwz">
          {bonuses.map(bonus => <article key={bonus.label} className="overflow-hidden rounded-3xl bg-white/[0.06] ring-1 ring-white/10" data-id="element-97" data-mp="15sgrlq7wvkpb">
              <img src={bonus.image} alt={`${bonus.title} — visual mockup of the included bonus materials`} className="w-full bg-white" width={1080} height={1080} data-id="element-98" data-mp="w2nhyurbxfnp" />

              <div className="px-5 py-6 sm:px-7" data-id="element-99" data-mp="n0e8m87srsbw">
                <div className="flex flex-wrap items-center gap-3" data-id="element-100" data-mp="r3axggnxkkoa">
                  <span className="rounded-full bg-gold-500 px-3 py-1 font-display text-[10px] font-black uppercase tracking-[0.18em] text-navy-950" data-id="element-101" data-mp="d4b44vph3hls">
                    {bonus.label}
                  </span>
                  <span className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-wide" data-id="element-102" data-mp="2jsbkuvx94m9u">
                    <span className="text-brand-100/50 line-through" data-id="element-103" data-mp="2f1bl7iwqzq3n">Value {bonus.value}</span>
                    <span className="text-gold-500" data-id="element-104" data-mp="2azqdsd2zg40u">Free</span>
                  </span>
                </div>

                <h3 className="mt-4 font-display text-lg font-black uppercase leading-tight sm:text-2xl" data-id="element-105" data-mp="261yakmww0vhc">
                  {bonus.title}
                </h3>
                <p className="mt-2.5 text-[14px] leading-relaxed text-brand-100/80 sm:text-[15px]" data-id="element-106" data-mp="32p3aro7atzmv">
                  {bonus.description}
                </p>

                {bonus.items && <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-107" data-mp="2tsu9s53oasym">
                    {bonus.items.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-108" data-mp="1ibktfrfuch1j">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-400" aria-hidden="true" data-id="element-109" data-mp="1i9hrc91eyxgg" />
                        <span className="text-[14px] font-medium leading-snug text-white" data-id="element-110" data-mp="1deudd441dlg4">{item}</span>
                      </li>)}
                  </ul>}

                <p className="mt-5 flex items-start gap-2 rounded-xl bg-navy-950/60 px-3.5 py-3 text-[13px] font-semibold leading-snug text-brand-100" data-id="element-111" data-mp="185jjf9jylj0e">
                  <ArrowRightIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-400" aria-hidden="true" data-id="element-112" data-mp="1hxp7i873bgab" />
                  {bonus.outcome}
                </p>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-10 max-w-xl text-center" data-id="element-113" data-mp="1qwkehmhykueo">
          <p className="font-display text-lg font-black uppercase leading-tight text-white sm:text-2xl" data-id="element-114" data-mp="1vwp0fs1myhca">
            Get all 5 bonuses without paying extra.
          </p>
          <div className="mt-6" data-id="element-115" data-mp="20tyszgkbn94c">
            <CTAButton tone="gold" onDark data-id="element-116" data-mp="1jz473nsow1q" />
          </div>
        </div>
      </div>
    </section>;
}